import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ErrorHandler, Injectable, Provider } from '@angular/core';
import { IError } from '@core/interfaces/api';
import { UNHANDLER_ERROR_MESSAGE } from '@core/utils/constants';
import { getNotifyBody } from '@core/utils/functions';
import { Notify } from 'notiflix';

@Injectable()
export class ErrorService implements ErrorHandler {
  handleError(error: Error | HttpErrorResponse) {
    if (!navigator.onLine) Notify.warning(getNotifyBody('Conexión débil', 'Revisa tu conexión a internet'));

    if (error instanceof HttpErrorResponse) this.handleHttpError(error);

    console.error(error);
  }

  private handleHttpError({ error, status }: IError) {
    let title = error?.error?.titulo ?? 'Error desconocido';
    let message = error?.message ?? error?.error?.mensaje ?? UNHANDLER_ERROR_MESSAGE;

    const timeoutCodes = [HttpStatusCode.GatewayTimeout, HttpStatusCode.RequestTimeout];

    if (timeoutCodes.includes(status)) {
      title = 'Tiempo agotado';
      message = 'La respuesta ha tardado en responder, intentálo de nuevo';
    }

    const isNotFound = status === HttpStatusCode.NotFound;
    const isForbidden = status === HttpStatusCode.Forbidden;

    if (isNotFound || isForbidden) return Notify.warning(getNotifyBody(title, message));

    Notify.failure(getNotifyBody(title, message));
  }
}

export function provideErrorHandler(): Provider {
  return [
    {
      provide: ErrorHandler,
      useClass: ErrorService
    },
    {
      provide: ErrorService,
      useClass: ErrorService
    }
  ];
}
